import { Injectable } from '@angular/core';

import { AccountService, TagService, UserService } from '../../../shared/services';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { User } from '../../../shared/models';

@Injectable({
  providedIn: 'root',
})
export class ChangedUserHandlerService {
  constructor(
    private userService: UserService,
    private authService: AuthService,
    private accountService: AccountService,
    private tagService: TagService,
  ) {}

  handle(user: User): void {
    const userIdFromToken: string = this.authService.getUserId();

    if (user && user?.userId !== userIdFromToken) {
      this.userService.updateCurrentUser(userIdFromToken);

      this.accountService.updateAccount(true);
      this.tagService.dispatchGetTagsCount();
    }
  }
}
